import {
	line_linearScale,
	line_callMade,
	line_arrow2,
	line_dotted,
	line_dashed
} from "./drawing-lines";

import { DrawingModuleContainer } from "../../ModuleBase/DrawingModuleContainer";
import { DrawLinesModule } from "./lines-module";

export class DrawLinesModuleContainer extends DrawingModuleContainer {
	constructor(canvas, getColor, drawingHistory) {
		super(canvas);

		this.moduleId = "lines";
		this.toolbarWidth = "40px";
		this.icon = line_linearScale;
		this.label = "line";

		const modules = [
			{ name: "straight", icon: line_linearScale },
			{ name: "dotted", icon: line_dotted },
			{ name: "dashed", icon: line_dashed },
			{ name: "arrow", icon: line_callMade },
			{ name: "arrow2", icon: line_arrow2 },
		];
		this.submodules = modules.map((m) => new DrawLinesModule(canvas, getColor, m.name, m.icon, drawingHistory));
	}
}

window.customElements.define(
	"inspx-draw-lines-container",
	DrawLinesModuleContainer
);
